<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button mr-1"
            title="Excluir anexo"
            @click.stop="confirmarExcluirAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        anexo: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirAnexo() {
            this.$swal({
                title: 'Exclusão de Arquivo',
                html: `Confirma a exclusão do arquivo <b>${this.anexo.nomeArquivoOriginal}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirAnexo()
                }
            })
        },

        excluirAnexo() {
            this.$store.dispatch('addRequest')
            let anexoExcluido = {
                idComprometimento: this.anexo.idComprometimentoRequisicao,
                comprometimentoAnexoId: this.anexo.comprometimentoAnexoId
            }
            this.dataServico
                .excluirComprometimentoAnexo(anexoExcluido)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Anexo excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-anexos-atualizados')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir anexo.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
